<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
    <Toast 
      :show="toast.show" 
      :message="toast.message" 
      :type="toast.type"
    />
  </div>
</template>

<script>
import Toast from './components/Toast.vue'

export default {
  name: 'App',
  components: {
    Toast
  },
  data() {
    return {
      toast: {
        show: false,
        message: '',
        type: 'success'
      }
    }
  },
  created() {
    // 添加全局事件總線
    this.$root.$on('show-toast', this.showToast)
  },
  beforeDestroy() {
    this.$root.$off('show-toast', this.showToast)
  },
  methods: {
    showToast({ message, type = 'success', duration = 2000 }) {
      this.toast = {
        show: true,
        message,
        type
      }
      
      if (type === 'loading') {
        return
      }
      
      setTimeout(() => {
        this.toast.show = false
      }, duration)
    }
  }
}
</script>

<style>
@import './assets/css/style.css';

/* 過渡效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

/* 確保過渡效果在路由切換前完成 */
.fade-leave-active {
  position: absolute;
  width: 100%;
}
</style> 